import { ArrowDown, ArrowUp } from "lucide-react";
import React, { useState } from "react";
import "./Home.scoped.scss";

const NewsDesktop = ({ news, handleNavigate, isCustomImage, nextSlide, prevSlide, currentIndex, total, setLoading }) => {

  const topIndex = currentIndex;
  const bottomIndex = (currentIndex + 1) % total;

  return (
    <div className="news-container-desktop">
      <div
        className="top-news"
        onClick={() =>
          handleNavigate(
            news[topIndex]?.Type,
            news[topIndex]?.Id
          )
        }
      >
        {news[topIndex]?.IconUrl ? (
          <img
            src={
              isCustomImage(news[topIndex]?.IconUrl)
                ? `/img/vendors/news/${news[topIndex]?.IconUrl}.jpg`
                : `api/Announcement/Image/${news[topIndex]?.IconUrl}`
            }
            alt="news-banner"
            onLoad={() => setLoading(false)}
          />
        ) : (
          <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '437px', width: '100%' }}>
            <h1 className='text-secondary text-center'>Please stay tuned</h1>
            <h1 className='text-secondary text-center'>for the</h1>
            <h1 className='text-secondary text-center'>news soon.</h1>
          </div>
        )}
      </div>
      <div className="slider-container">
        <div className="slider-button">
          <div className="arrow-button" onClick={nextSlide}>
            <ArrowUp size={24} />
          </div>
          <div className="arrow-button" onClick={prevSlide}>
            <ArrowDown size={24} />
          </div>
        </div>
        <div
          className="bottom-news"
          onClick={() =>
            handleNavigate(
              news[bottomIndex]?.Type,
              news[bottomIndex]?.Id
            )
          }
        >
          {news[bottomIndex]?.IconUrl && total > 1 ? (
            <img
              src={
                isCustomImage(news[bottomIndex]?.IconUrl)
                  ? `/img/vendors/news/${news[bottomIndex]?.IconUrl}.jpg`
                  : `api/Announcement/Image/${news[bottomIndex]?.IconUrl}`
              }
              alt="news-banner"
              onLoad={() => setLoading(false)}
            />
          ) : (
            <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '100%', width: '100%' }}>
              <h1 className='text-secondary text-center'>Please stay tuned</h1>
              <h1 className='text-secondary text-center'>for the</h1>
              <h1 className='text-secondary text-center'>news soon.</h1>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewsDesktop;
